import { AfterViewInit, Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CreateBuergscheinModel } from '../../../model.module/create-buergschein.model';

@Component({
    selector: 'print-buergschein-antrag',
    templateUrl: './bgsch-antrag.component.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PrintBuergscheinAntrag implements AfterViewInit {

    @Input()
    model: CreateBuergscheinModel = null;

    @Input()
    shown: boolean = false;

    printButtonDisabled: boolean = true;

    notifyOpen(open: boolean): void {
        this.shown = open;
    }

    ngAfterViewInit(): void {
        // Aktiviere Print-Button erst, wenn alle Elemente geladen sind
        setTimeout(_=> this.printButtonDisabled = false);
    }

}

